// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import { tr } from '../utils/locale';

class SimpleCard extends Component {
    render() {
        const {
            title,
            subtitle,
            className,
            testId,
            children,
            isSelected,
            isActive,
            isDisabled,
            isFavorite,
            isInline,
            isDemo,
            ...rest
        } = this.props;
        return (
            <div
                className={cl(
                    'simplecard',
                    { active: isActive },
                    { 'simplecard--demo': isDemo },
                    { disabled: isDisabled },
                    { 'simplecard--selected': isSelected },
                    { inline: isInline },
                    className
                )}
                data-testid={testId}
                {...rest}
            >
                {title && (
                    <div className="simplecard__title" data-testid={`${testId}-title`}>
                        {title}
                    </div>
                )}
                {isFavorite && (
                    <Icon
                        className="simplecard__favorite"
                        title={tr('Favorite Project')}
                        icon="star-filled"
                        isFill
                        size={18}
                        data-testid={`${testId}-icon`}
                    />
                )}
                {subtitle && (
                    <div className="simplecard__subtitle" data-testid={`${testId}-subtitle`}>
                        {subtitle}
                    </div>
                )}
                {children && (
                    <div className="simplecard__content" data-testid={`${testId}-content`}>
                        {children}
                    </div>
                )}
            </div>
        );
    }
}

SimpleCard.defaultProps = {
    title: '',
    subtitle: '',
    className: '',
    testId: 'simple-card',
    children: null,
    isSelected: false,
    isActive: false,
    isDisabled: false,
    isFavorite: false,
    isInline: false,
    isDemo: false,
};

SimpleCard.propTypes = {
    isSelected: PropTypes.bool,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    children: PropTypes.node,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    className: PropTypes.string,
    testId: PropTypes.string,
    isFavorite: PropTypes.bool,
    isInline: PropTypes.bool,
    isDemo: PropTypes.bool,
};

export default SimpleCard;
